var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4062 2.78125C17.1875 3.5625 17.1875 4.8125 16.4062 5.59375L5.375 16.625L1.8125 17C1.34375 17.0625 0.9375 16.6562 1 16.1875L1.375 12.625L12.4062 1.59375C13.1875 0.8125 14.4375 0.8125 15.2188 1.59375L16.4062 2.78125ZM13.4375 7.15625L10.8438 4.5625L3.84375 11.5625H4.9375V13.0625H6.4375V14.1562L13.4375 7.15625ZM4.9375 15.6562L5.5625 15.0312V13.9375H4.0625V12.4375H2.96875L2.34375 13.0625L2.125 14.9062L3.09375 15.875L4.9375 15.6562ZM15.6875 4.90625C16.0938 4.5 16.0938 3.875 15.6875 3.46875L14.5312 2.3125C14.125 1.90625 13.5 1.90625 13.0938 2.3125L11.5312 3.875L14.125 6.46875L15.6875 4.90625Z",
    fill: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/Pencil.c2c919d5d74c65627acb406614e649b2.svg";
export { ForwardRef as ReactComponent };